module.exports = __webpack_public_path__ + "static/img/pic_about_img.0e7fe27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pic_about_img.jpg
// module id = 1iBL
// module chunks = 0